import { supabase } from "@/integrations/supabase/client";

export interface UnsplashPhoto {
  id: string;
  description: string | null;
  width: number;
  height: number;
  color: string | null;
  url: string;
  thumbUrl: string;
  htmlLink: string;
  author: {
    name: string;
    username: string;
    link: string;
  };
}

export type UnsplashOrientation = 'landscape' | 'portrait' | 'squarish';

export interface SearchUnsplashPhotosParams {
  query: string;
  page?: number;
  per_page?: number;
  orientation?: UnsplashOrientation;
}

export interface SearchUnsplashPhotosResponse {
  results: UnsplashPhoto[];
  total: number;
  total_pages: number;
}

/**
 * Ricerca foto su Unsplash tramite l'edge function search-unsplash-photos.
 */
export const searchUnsplashPhotos = async (
  params: SearchUnsplashPhotosParams,
): Promise<SearchUnsplashPhotosResponse> => {
  const { data, error } = await supabase.functions.invoke("search-unsplash-photos", {
    body: params,
  });

  if (error) throw error;
  return data as SearchUnsplashPhotosResponse;
};

export interface GetRandomUnsplashPhotoParams {
  query?: string;
  orientation?: UnsplashOrientation;
}

/**
 * Recupera una foto casuale da Unsplash tramite l'edge function random-unsplash-photo.
 * Usata per generare il placeholder cover quando si crea un nuovo itinerario.
 */
export const getRandomUnsplashPhoto = async (
  params: GetRandomUnsplashPhotoParams = {},
): Promise<UnsplashPhoto> => {
  const { data, error } = await supabase.functions.invoke("random-unsplash-photo", {
    body: params,
  });

  if (error) throw error;
  return (data as { photo: UnsplashPhoto }).photo;
};
